import { Pipe, PipeTransform } from '@angular/core';
import { NetworkProvider } from '../providers/network';

@Pipe({
  name: 'networkMessages'
})

export class NetworkMessagesPipe implements PipeTransform {

  constructor(
    private networkProvider: NetworkProvider
  ) { }

  transform(value: string, cUser: string, clientId: string): any {
    return this.networkProvider.getNetworkMessages(cUser, value, clientId);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/network-messages.pipe.ts